import { Select } from 'antd';

export const SelectOption = ({ options, ...restProps }) => {
  return <Select virtual={false} options={options} {...restProps} />;
};
